import React, { useEffect, useState } from "react";
import AssetRegisterRow from "./AssetRegisterRow";

export default function AssetRegisterDrawer(
{
    open,
    assets,
    onClose
})
{
    const [rows, setRows] = useState([]);

    useEffect(function ()
    {
        setRows(
            (assets || []).map(function (asset)
            {
                return {

                    ...asset,

                    selected: true,

                    assetCode: "",

                    category: asset.type || "",

                    manufacturer: "",

                    model: "",

                    serialNumber: "",

                    condition: asset.condition || "Good",

                    criticality: "Medium"

                };
            })
        );
    }, [assets]);

    function updateRow(index, field, value)
    {
        setRows(function(previous)
        {
            const updated =
                [...previous];

            updated[index] =
            {
                ...updated[index],
                [field]: value
            };

            return updated;
        });
    }

    const cardStyle =
    {
        background: "#22272e",
        border: "1px solid #333b44",
        borderRadius: "12px",
        padding: "18px",
        width: "150px",
        textAlign: "center",
        boxShadow: "0 6px 14px rgba(0,0,0,.18)"
    };

    const numberStyle =
    {
        fontSize: "34px",
        fontWeight: "bold",
        color: "#5a9bd6"
    };

    const labelStyle =
    {
        marginTop: "8px",
        color: "#fff",
        fontSize: "11px",
        letterSpacing: "1px",
        textTransform: "uppercase"
    };
	
	
	

    return (

        <div
            style={{
                position: "absolute",
                top: 0,
                left: open ? 0 : "-100%",
                width: "calc(100% - 390px)",
                height: "100%",
                background: "#eef2f6",
                transition: "left .35s ease",
                boxShadow: "8px 0 30px rgba(0,0,0,.35)",
                display: "flex",
                flexDirection: "column",
                zIndex: 19,
				boxShadow: "8px 0 30px rgba(0,0,0,0.35)",
            }}
        >

            <div
                style={{
                    background: "linear-gradient(135deg,#1b1f25,#2b3138)",
                    color: "#fff",
                    padding: "28px 32px"
                }}
            >

                <div
                    style={{
                        fontSize: "30px",
                        fontWeight: "bold"
                    }}
                >
                    Populate Asset Register
                </div>

                <div
                    style={{
                        marginTop: "6px",
                        color: "#c6ccd3",
                        fontSize: "14px"
                    }}
                >
                    Review AI generated assets before importing them into your Building Book.
                </div>

                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "flex-end",
                        marginTop: "28px"
                    }}
                >

                    <div
                        style={{
                            display: "flex",
                            gap: "18px"
                        }}
                    >

                        <div style={cardStyle}>
                            <div style={numberStyle}>
                                {rows.length}
                            </div>

                            <div style={labelStyle}>
                                Assets
                            </div>
                        </div>

                        <div style={cardStyle}>
                            <div style={numberStyle}>
                                {
                                    rows.filter(function(r)
                                    {
                                        return r.selected;
                                    }).length
                                }
                            </div>

                            <div style={labelStyle}>
                                Ready
                            </div>
                        </div>

                        <div style={cardStyle}>
                            <div style={numberStyle}>
                                {
                                    rows.filter(function(r)
                                    {
                                        return r.confidence < 0.80;
                                    }).length
                                }
                            </div>

                            <div style={labelStyle}>
                                Review
                            </div>
                        </div>

                        <div style={cardStyle}>
                            <div style={numberStyle}>
                                {
                                    rows.length
                                    ?
                                    Math.round(
                                        rows.reduce(function(total,row)
                                        {
                                            return total + row.confidence;
                                        },0) * 100 / rows.length
                                    )
                                    :
                                    0
                                }%
                            </div>

                            <div style={labelStyle}>
                                Confidence
                            </div>
                        </div>

                    </div>

					<div
					    style={{
					        display: "flex",
					        flexDirection: "column",
					        gap: "12px",
					        alignItems: "stretch",
					        minWidth: "220px"
					    }}
					>

					    <button
					        onClick={onClose}
					        style={{
					            background: "#fff",
					            border: "1px solid #bfc5cd",
					            borderRadius: "8px",
					            padding: "12px",
					            cursor: "pointer",
					            fontWeight: "bold"
					        }}
					    >
					        Cancel
					    </button>

					    <button
					        style={{
					            background: "#5a9bd6",
					            color: "#fff",
					            border: "none",
					            borderRadius: "8px",
					            padding: "14px",
					            fontWeight: "bold",
					            fontSize: "16px",
					            cursor: "pointer",
					            boxShadow: "0 8px 20px rgba(90,155,214,.35)"
					        }}
					    >
					        Save {rows.length} Assets
					    </button>

					</div>

                </div>

            </div>

            <div
                style={{
                    background: "#fff",
                    padding: "18px 30px",
                    borderBottom: "1px solid #dde3ea",
                    display: "flex",
                    gap: "35px",
                    fontSize: "14px"
                }}
            >

                <label>
                    <input
                        type="checkbox"
                        defaultChecked
                    />
                    {" "}
                    Auto-generate Asset Codes
                </label>

                <label>
                    <input
                        type="checkbox"
                    />
                    {" "}
                    Generate QR Codes
                </label>

                <label>
                    <input
                        type="checkbox"
                    />
                    {" "}
                    Add to Building Book
                </label>

            </div>

            <div
                style={{
                    flex: 1,
                    overflowY: "auto",
                    padding: "28px"
                }}
            >

			<AssetRegisterRow />
            </div>

        </div>

    );
}